import React, { ReactElement } from 'react';
import styles from './passwordUpdatedPage.module.scss';
import { Title } from '../../../components/title/Title';
import { LoadableButton } from '@mo/loadable-button';

interface PasswordUpdatedPageProps {
    resumeButtonText: string;
    resumeUrl: string;
}

const PasswordUpdatedPage = ({ resumeButtonText, resumeUrl }: PasswordUpdatedPageProps): ReactElement => {
    return (
        <div className={styles.gridContainer}>
            <div className={styles.page}>
                <div className={styles.form}>
                    <div className={styles.formHeader}>
                        <div className={styles.formHeaderContent}>
                            <Title title='Your password has been updated' />
                        </div>
                    </div>
                    <p>You will shortly receive an email confirming this change.</p>
                    <LoadableButton
                        loading={false}
                        loadingText={resumeButtonText}
                        notLoadingText={resumeButtonText}
                        onClick={(): void => window.location.replace(resumeUrl)}
                        className={styles.signInButton}
                    />
                </div>
            </div>
        </div>
    );
};

export default PasswordUpdatedPage;
